import React from 'react';

import styles from './BannerInFilter.css';

export const BannerInFilter: React.FC = ({ children }) => <div className={styles['banner']}>{children}</div>;
